import { render, staticRenderFns } from "./StandardDialog.vue?vue&type=template&id=f70bf19e&scoped=true&"
import script from "./StandardDialog.vue?vue&type=script&lang=js&"
export * from "./StandardDialog.vue?vue&type=script&lang=js&"
import style0 from "./StandardDialog.vue?vue&type=style&index=0&id=f70bf19e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70bf19e",
  null
  
)

export default component.exports